import axios from "axios";
import { redirectFunc } from "../../utils/redirect";

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { STATUS, tokenKey } from "../../utils/constants";

export const fetchEventBooking = createAsyncThunk(
  "fetch_event_booking",
  async (bookingId, { fulfillWithValue, rejectWithValue }) => {
    const token = localStorage.getItem(tokenKey);

    try {
      const response = await axios.get(
        `${
          process.env.REACT_APP_BASE_URL
        }Events/FetchEventBooking?bookingId=${encodeURIComponent(bookingId)}`,
        { headers: { Authorization: "Bearer " + token } },
      );

      const eventBookingData = response.data?.data;

      if (!eventBookingData || eventBookingData.isValid === false) {
        return rejectWithValue(
          "This event booking is invalid or has already been redeemed",
        );
      }

      return fulfillWithValue({
        ...eventBookingData,
        // filmName comes back inside `data`; fall back to the top level too.
        filmName: eventBookingData.filmName || response.data?.filmName || "",
        totalQuantity: (eventBookingData.ticketSales || []).reduce(
          (sum, ticketSale) => sum + (+ticketSale?.quantity || 0),
          0,
        ),
      });
    } catch (err) {
      redirectFunc({ ...err });

      const error = { ...err };
      let message = "Unable to complete request";

      return rejectWithValue(
        error?.response?.data?.errors?.[0]?.errorMessages?.[0] || message,
      );
    }
  },
);

const initialState = {
  error: "",
  status: STATUS.IDLE,
  eventBookingData: {},
};

export const eventBookingSlice = createSlice({
  name: "eventBooking",
  initialState,
  reducers: {
    resetEventBooking: (state) => {
      state.error = "";
      state.status = STATUS.IDLE;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEventBooking.pending, (state) => {
        state.error = "";
        state.status = STATUS.PENDING;
      })
      .addCase(fetchEventBooking.fulfilled, (state, action) => {
        state.error = "";
        state.status = STATUS.RESOLVED;
        state.eventBookingData = action.payload;
      })
      .addCase(fetchEventBooking.rejected, (state, action) => {
        state.error = action.payload;
        state.status = STATUS.REJECTED;
      });
  },
});

export const { resetEventBooking } = eventBookingSlice.actions;
export const eventBookingReducer = eventBookingSlice.reducer;
